import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import "./style.scss";
import parse from "html-react-parser";

export function ResponseArea(props) {
  const inputRef = useRef();

  useEffect(() => {
    if (inputRef.current.value === null || inputRef.current.value === "") {
      inputRef.current.value = props.answer;
    }
  }, []);

  const updateResponseArea = () => {
    const value = inputRef.current.value;
    props.onValueChange(value);
    props.setEnableSubmitButton(value !== null && value !== "");
  };

  const wrapperClass = () => {
    const classList = [props.className, "responseArea"];
    return classList.join(" ");
  };

  return (
    <>
      <div className={wrapperClass()}>
        <textarea
          id={props.id}
          rows="4"
          className="textarea-input"
          onInput={(e) => updateResponseArea(e)}
          disabled={props.disabled}
          placeholder="Answer here."
          ref={inputRef}
        />
      </div>
      {props.feedback && props.renderFeedback && (
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            padding: "8px",
            background: "#F5F7F9",
            border: "1px solid #336589",
            borderRadius: "5px",
            justifyContent: "center",
            margin: "8px 0",
          }}
        >
          {props.feedbackIcon && (
            <div>
              <img
                alt="Feedback icon."
                src={props.FeedbackIcon}
                style={{ margin: 0 }}
              />
            </div>
          )}

          <p
            style={{ flex: 1, margin: "0 0 0 8px", whiteSpace: "pre-wrap" }}
            className={"OpenEndedFeedback"}
          >
            {parse(props.feedback)}
          </p>
        </div>
      )}
    </>
  );
}

ResponseArea.propTypes = {
  className: PropTypes.string,
  feedback: PropTypes.string,
  disabled: PropTypes.bool,
  feedbackIcon: PropTypes.string,
  setEnableSubmitButton: PropTypes.func,
  saveUserResponse: PropTypes.func,
};
